import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/tuskerzk.png'


const _withScopeId = n => (_pushScopeId("data-v-0e5cae8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navbar is-primary",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "navbar-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "117",
    height: "28",
    src: _imports_0,
    alt: "TuskerZK Logo"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "navbar-start" }
const _hoisted_9 = { class: "navbar-end" }
const _hoisted_10 = { class: "navbar-item" }
const _hoisted_11 = { class: "select" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "navbar-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("a", {
        role: "button",
        class: "navbar-burger",
        "aria-label": "menu",
        "aria-expanded": "false",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleBurgerMenu && _ctx.toggleBurgerMenu(...args)), ["prevent"]))
      }, _hoisted_7)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["navbar-menu", _ctx.showMenu ? 'is-active' : ''])
    }, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            class: "navbar-item",
            to: link.target
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(link.text), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.eventId) = $event)),
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateEventId && _ctx.updateEventId(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allEvents, (event) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: event.id,
                  value: event.id
                }, _toDisplayString(event.name), 9, _hoisted_12))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.eventId]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.email), 1)
      ])
    ], 2)
  ]))
}